import React from 'react';
import { Modal, Button, Form } from 'antd';
import { SelectModulNotif, SelectStatusNotif } from 'components/select';

const ModalFilter = ({ values, visible, hideModal, setTempTableFilter, setTableFilterFromTemp }) => {
    return (
        <Modal
            title="Filter"
            width={300}
            open={visible}
            onCancel={hideModal}
            footer={<>
                <Button onClick={hideModal}>Tutup</Button>
                <Button type='primary' onClick={setTableFilterFromTemp}>Terapkan</Button>
            </>}
        >
            <Form
                name="basic"
                autoComplete="off"
                layout="vertical"
            >
                <Form.Item label="Modul">
                    <SelectModulNotif
                        allowClear
                        value={values.modul}
                        onChange={(val) => {
                            setTempTableFilter("modul", val || null);
                        }}
                    />
                </Form.Item>
                <Form.Item label="Status">
                    <SelectStatusNotif
                        allowClear
                        value={values.status}
                        onChange={(val) => {
                            setTempTableFilter("status", val || null);
                        }}
                    />
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default ModalFilter;
